import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/stocksIssue`;

export const stockIssueService = {
  getAll,
  getSuggestion,
  search,
  getById,
  getByViewId,
  printPdf,
  printMudPdf,
  printExcel,
  exportExcel,
  create,
  update,
  updateDetails,
  confirm,
  deliveryUpdate,
  delete: _delete,
  deleteLineItem,
  deleteLine,
  uploadAsyCudaFile,
  getAsycuda,
  getHistory,
  getDocuments,
  getTransactions,
  updateStatus,
  deleteItem,
  addItem,
  getAvailableStockReceipts,
  getWriteOffFromIssue,
  updateWriteOff,
  getAvailableStocks,
  exportAvailableStocksExcel,
};

function getAll() {
  return fetchWrapper.get(baseUrl);
}

function search(params) {
  return fetchWrapper.get(`${baseUrl}${params}`);
}

function getSuggestion(params) {
  return fetchWrapper.get(`${baseUrl}/suggestion${params}`);
}

function getById(id) {
  return fetchWrapper.get(`${baseUrl}/${id}`);
}

function getByViewId(id) {
  return fetchWrapper.get(`${baseUrl}/view/${id}`);
}

function printPdf(id, summaryFlag) {
  return fetchWrapper.get(`${baseUrl}/${id}/printPdf?summary=${summaryFlag}`, {
    responseType: "blob",
  });
}

function printExcel(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/printExcel`, {
    responseType: "blob",
  });
}

function exportExcel(params) {
  return fetchWrapper.get(`${baseUrl}/export-excel${params}`, {
    responseType: "blob",
  });
}

function exportAvailableStocksExcel(params) {
  return fetchWrapper.get(`${baseUrl}/available/export-excel${params}`, {
    responseType: "blob",
  });
}

function create(params) {
  return fetchWrapper.post(baseUrl, params);
}

function update(id, params) {
  return fetchWrapper.put(`${baseUrl}/${id}`, params);
}

function updateDetails(id, params) {
  return fetchWrapper.put(`${baseUrl}/${id}/vehicle`, params);
}

function confirm(id, params) {
  return fetchWrapper.put(`${baseUrl}/${id}/confirm`, params);
}

function deliveryUpdate(id, params) {
  return fetchWrapper.put(`${baseUrl}/${id}/delivered`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`${baseUrl}/${id}`);
}

function deleteLineItem(id, stockItemId) {
  return fetchWrapper.delete(`${baseUrl}/${id}/lineItem/${stockItemId}`);
}

function deleteLine(id, lineId) {
  return fetchWrapper.delete(`${baseUrl}/${id}/line/${lineId}`);
}

function printMudPdf(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/printMudPdf`, {
    responseType: "blob",
  });
}

///api/stocksIssue/482ad662028745aa8146623381581685/printMudPdf

function uploadAsyCudaFile(params) {
  return fetchWrapper.post(`${baseUrl}/asycuda`, params);
}

function getAsycuda(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/asycuda`);
}

function getHistory(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/history`);
}

function getDocuments(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/document`);
}

function getTransactions(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/transaction`);
}

function updateStatus(id, params) {
  return fetchWrapper.put(`${baseUrl}/${id}/updateStatus`, params);
}

function deleteItem(issueId, id) {
  return fetchWrapper.put(`${baseUrl}/${issueId}/revoke/${id}`);
}

function addItem(issueLineId, params) {
  return fetchWrapper.put(`${baseUrl}/${issueLineId}/addItem`, params);
}

function getAvailableStocks() {
  return fetchWrapper.get(`${baseUrl}/available`);
}
function getAvailableStockReceipts(params) {
  return fetchWrapper.get(`${baseUrl}/available${params}`);
}

function getWriteOffFromIssue(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/writeOffView`);
}

function updateWriteOff(issueId, params) {
  return fetchWrapper.put(`${baseUrl}/${issueId}/writeOff`, params);
}
